import styled from 'styled-components';
import {Palette} from 'hubbl-shared';

export const DropdownItem = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px;
  cursor: pointer;
  border-radius: 4px;
  transition: all 0.15s ease-out;
  transform-origin: center;

  &:hover {
    background: ${Palette.white};
    transform: scale(1.02);
    border-radius: 8px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  }
`;
